

























































import { CourseVisibility } from '@/jbi-shared/types/jtms.types';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

interface VisibilityOption {
  value: string;
  label: string;
  subLabel: string;
  icon: string;
}

@Component
export default class PublishVisibilityDropdown extends Vue {
  @Prop({ type: String, required: true })
  readonly value!: string;

  // Define the available options
  get options(): VisibilityOption[] {
    return [
      {
        value: CourseVisibility.PRIVATE,
        label: 'Private',
        subLabel: 'Only visible to admins',
        icon: 'lock-outline' // Or just 'lock' depending on your icon pack
      },
      {
        value: CourseVisibility.PUBLIC,
        label: 'Public',
        subLabel: 'Visible to public and admins',
        icon: 'web' // Or 'earth', 'globe'
      }
    ];
  }

  // Helper to get the currently selected option object
  get selectedOption(): VisibilityOption {
    return this.options.find((o) => o.value === this.value) || this.options[0];
  }

  @Emit('input')
  handleInput(newValue: string) {
    return newValue;
  }
}
